<template>

    <section class="section">
        <div class="container">
            <div class="text-title">Training Webinars</div>
            <q-card>
                <q-card-section :class="{'q-px-xl' : screenSize.gt.sm, 'q-px-md' : screenSize.lt.md}">
                    <img :src="form.productLine.logo" class="img-webinar q-mt-md q-mb-sm" :title="form.productLine.name" />
                    <p>Choose your product for the latest webinar information.</p>
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-4">
                            <q-select outlined dense class="q-mb-md"
                                      bg-color="white"
                                      label="Product Type" stack-label
                                      autocomplete="off"
                                      @input="updateRoute"
                                      v-model="form.productLine" :options="productLines"
                                      option-label="name"
                                      hide-bottom-space />
                        </div>
                    </div>
                </q-card-section>
            </q-card>
            <div v-if="webinarSessions && webinarSessions.length > 0" class="row">
                <div class="col">
                    <div class="text-subtitle">Live Webinars</div>
                    <p>Below is a listing of live webinars. Simply click the "Register" links to reserve your space and receive the information required to join the session.</p>
                    <q-table wrap-cells hide-pagination
                             color="primary"
                             card-container-class="q-col-gutter-md"
                             table-header-class="bg-primary text-white"
                             :grid="screenSize.lt.md"
                             :dense="screenSize.xs"
                             :loading="getWebinarSessionsPending"
                             :hide-no-data="getWebinarSessionsPending"
                             :data="webinarSessions" :columns="columnsSession"
                             :pagination.sync="pagination" row-key="id"
                             :hide-bottom="(webinarSessions && webinarSessions.length > 0)">

                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td v-for="col in props.cols"
                                      :key="col.name"
                                      :props="props"
                                      :style="col.name=='memberExclusive' ? 'padding-right: 0.15em !important;' : ''">
                                    <div v-if="col.name=='registrationLink'">
                                        <a @click.prevent="registerWebinar(props.row)" :href="col.value" target="_blank">Register Now</a>
                                    </div>
                                    <div v-else-if="col.name=='title'">
                                        <div class="row text-weight-medium">
                                            {{ col.value }}
                                        </div>
                                        <div class="row">
                                            {{ props.row.description }}
                                        </div>
                                    </div>
                                    <div v-else-if="col.name=='memberExclusive'">
                                        <q-icon :name="getHasMemberExclusiveData ? 'mdi-lock-open-variant' : 'mdi-lock'"
                                                :color="props.row.memberExclusive && getHasMemberExclusiveData ? 'positive' : ''"
                                                v-if="col.value" size="1.2em"></q-icon>
                                    </div>
                                    <div v-else>
                                        {{ col.value }}
                                    </div>
                                </q-td>
                            </q-tr>
                        </template>

                        <template v-slot:item="props">
                            <div class="col-xs-12 col-sm-6">
                                <q-card class="full-height">
                                    <q-item class="row full-height q-py-lg q-px-md ">
                                        <q-item-section class="column justify-between">
                                            <div>
                                                <q-item-label class="text-weight-medium">{{ props.row.title }}</q-item-label>
                                                <q-item-label>{{ props.row.description }}</q-item-label>
                                                <q-item-label caption class="q-pt-sm">Event Date: {{ props.row.eventDate | date }}</q-item-label>
                                                <q-item-label caption>Event Time: {{ props.row.eventTime }}</q-item-label>
                                                <q-item-label caption>Duration: {{ props.row.duration }}</q-item-label>
                                            </div>
                                            <div class="row justify-center q-mt-md">
                                                <q-btn @click="registerWebinar(props.row)"
                                                       outline dense class="full-width"><q-icon :name="props.row.memberExclusive ? getHasMemberExclusiveData ? 'mdi-lock-open-variant' : 'mdi-lock' : 'mdi-calendar-check'"
                                                                                                :color="props.row.memberExclusive && getHasMemberExclusiveData ? 'positive' : ''"
                                                                                                :size="props.row.memberExclusive ? '1.2em' : '1.4em'" class="on-left"></q-icon>Register</q-btn>
                                            </div>
                                        </q-item-section>
                                    </q-item>
                                </q-card>
                            </div>
                        </template>
                    </q-table>
                </div>
            </div>
            <div v-if="webinarDownloads && webinarDownloads.length > 0" class="row">
                <div class="col">
                    <div class="text-subtitle">Recorded Webinars</div>
                    <p>Selected past webinars are available for here to download, so you can watch them at your convenience. Save these webinars to your local hard drive, then simply double-click to launch the recorded webinar.</p>
                    <q-table wrap-cells hide-pagination
                             card-container-class="q-col-gutter-md"
                             :grid="screenSize.lt.md"
                             color="primary"
                             table-header-class="bg-primary text-white"
                             :dense="screenSize.xs"
                             :loading="getWebinarDownloadsPending"
                             :hide-no-data="getWebinarDownloadsPending"
                             :data="webinarDownloads" :columns="columnsDownload"
                             :pagination.sync="pagination" row-key="id"
                             :hide-bottom="(webinarDownloads && webinarDownloads.length > 0)">

                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td v-for="col in props.cols"
                                      :key="col.name"
                                      :props="props"
                                      :style="col.name=='memberExclusive' ? 'padding-right: 0.15em !important;' : ''">
                                    <div v-if="col.name=='actions'">
                                        <q-btn v-show="props.expand == false"
                                               :loading="props.expand"
                                               @click="serveWebinar(props)"
                                               :disable="props.expand == true"
                                               flat dense icon="mdi-download"><q-tooltip>Download</q-tooltip></q-btn>
                                    </div>
                                    <div v-else-if="col.name=='title'">
                                        <div class="row text-weight-medium">
                                            {{ col.value }}
                                        </div>
                                        <div class="row">
                                            {{ props.row.description }}
                                        </div>
                                    </div>
                                    <div v-else-if="col.name=='memberExclusive'">
                                        <q-icon :name="getHasMemberExclusiveData ? 'mdi-lock-open-variant' : 'mdi-lock'"
                                                :color="props.row.memberExclusive && getHasMemberExclusiveData ? 'positive' : ''"
                                                v-if="col.value" size="1.2em"></q-icon>
                                    </div>
                                    <div v-else>
                                        {{ col.value }}
                                    </div>
                                </q-td>
                            </q-tr>
                        </template>

                        <template v-slot:item="props">
                            <div class="col-xs-12 col-sm-6">
                                <q-card class="full-height">
                                    <q-item class="row full-height q-py-lg q-px-md ">
                                        <q-item-section class="column justify-between">
                                            <div>
                                                <q-item-label class="text-weight-medium">{{ props.row.title }}</q-item-label>
                                                <q-item-label>{{ props.row.description }}</q-item-label>
                                                <q-item-label caption class="q-pt-sm">Record Date: {{ props.row.recordDate | date }}</q-item-label>
                                                <q-item-label caption>Duration: {{ props.row.duration }}</q-item-label>
                                                <q-item-label caption>File Size: {{ props.row.fileSize }}</q-item-label>
                                            </div>
                                            <div class="row justify-center q-mt-md">

                                                <q-btn @click="serveWebinar(props)"
                                                       :loading="props.expand"
                                                       outline dense class="full-width"
                                                       :disable="props.expand == true">
                                                    <q-icon v-show="props.expand == false"
                                                            :name="props.row.memberExclusive ? getHasMemberExclusiveData ? 'mdi-lock-open-variant' : 'mdi-lock' : 'mdi-download'"
                                                            :color="props.row.memberExclusive && getHasMemberExclusiveData ? 'positive' : ''"
                                                            :size="props.row.memberExclusive ? '1.2em' : ''" class="on-left" />
                                                    <span v-show="props.expand == false">Download</span>
                                                </q-btn>
                                            </div>
                                        </q-item-section>
                                    </q-item>
                                </q-card>
                            </div>
                        </template>
                    </q-table>
                </div>
            </div>
            <div v-if="webinarDownloads.length || webinarSessions.length" class="q-mt-md">
                <p class="text-caption row items-center"><q-icon name="mdi-lock" size="xs" class="on-left col-auto" /><span class="col">Denotes webinars only available to licensed users of {{ form.productLine.name }} with an active subscription. You will need to login to your account to verify the status.&nbsp;<router-link :to='`/activation/${form.productLine.name.toLowerCase()}?option=renew`'>Click here</router-link>&nbsp;to renew your subscription now.</span></p>
            </div>
            <div v-if="getWebinarDownloadsPending || getWebinarSessionsPending" class="text-center q-my-xl">
                <q-spinner color="primary"
                           :thickness="2"
                           size="3em" />
            </div>
            <q-inner-loading :showing="getHasMemberExclusivePending">
                <div>
                    <q-spinner color="primary"
                               :thickness="2"
                               size="3em" />
                </div>
            </q-inner-loading>
        </div>

        <q-dialog v-model="showMemberOnly">
            <q-card>
                <q-card-section>
                    <div class="text-h6 row items-center"><q-icon name="mdi-lock" class="q-mr-xs" />Webinar Locked</div>
                </q-card-section>

                <q-card-section class="q-py-none">
                    A valid license could not be found or has expired.The webinar you are trying to access is only available to licensed users of {{ form.productLine.name || 'LoopCAD' }} with an active subscription. Please <router-link :to="`/activation/${ form.productLine.name || 'loopcad' }?option=renew`">click here</router-link> to renew your subscription.
                </q-card-section>

                <q-card-section>
                    <div class="row q-col-gutter-sm">
                        <div class="col-xs-12 col-sm-auto">
                            <q-btn label="Renew License" color="primary" :to="`/activation/${ form.productLine.name || 'loopcad' }?option=renew`" />
                        </div>
                        <div class="col-xs-12 col-sm-auto">
                            <q-btn flat label="Close" color="primary" v-close-popup />
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="showLogin">
            <login @close="showLogin = false" style="width: 100%; max-width: 375px;" />
        </q-dialog>
    </section>
</template>
<script>
    import { date } from 'quasar'
    import { mapState } from 'vuex'
    import { productLines } from '@/plugins/productLines'
    import login from '@/components/Login'

    export default {
        name: "webinars",
        components: {
            login,
        },
        data() {
            return {
                currentRegister: null,
                currentDownload: null,
                showMemberOnly: false,
                showLogin: false,
                productLines: Object.keys(productLines)?.map(key => {
                    return productLines[key]
                })?.filter(pl => pl.name.toLowerCase() !== 'lengthwise' && pl.name.toLowerCase() !== 'plumbingcad'),
                form: {
                    productLine: null,
                    selectedWebinar: null,
                },
                pagination: {
                    sortBy: 'desc',
                    descending: false,
                    page: 1,
                    rowsPerPage: 100
                    // rowsNumber: xx if getting data from a server
                },
                columnsDownload: [
                    { name: 'memberExclusive', label: '', align: 'left', field: 'memberExclusive', sortable: false },
                    { name: 'title', label: 'Description', align: 'left', field: 'title', sortable: false, style: 'min-width: 500px;' },
                    { name: 'recordDate', label: 'Record Date', align: 'center', field: 'recordDate', sortable: false, format: (val, row) => (val) ? `${date.formatDate(new Date(val), 'YYYY/MM/DD')}` : '' },
                    { name: 'duration', label: 'Duration', align: 'right', field: 'duration', sortable: false, style: 'min-width: 80px;' },
                    { name: 'fileSize', label: 'File Size', align: 'right', field: 'fileSize', sortable: false, style: 'min-width: 80px;' },
                    { name: 'actions', label: '', field: 'title', align: 'right' },
                ],
                columnsSession: [
                    { name: 'memberExclusive', label: '', align: 'left', field: 'memberExclusive', sortable: false },
                    { name: 'title', label: 'Description', align: 'left', field: 'title', sortable: false, style: 'min-width: 500px;' },
                    { name: 'eventDate', label: 'Event Date', align: 'center', field: 'eventDate', sortable: false, format: (val, row) => (val) ? `${date.formatDate(new Date(val), 'YYYY/MM/DD')}` : '' },
                    { name: 'eventTime', label: 'Event Time', align: 'center', field: 'eventTime', sortable: false },
                    { name: 'duration', label: 'Duration', align: 'right', field: 'duration', sortable: false, style: 'min-width: 65px;' },
                    { name: 'registrationLink', label: 'Registration Link', align: 'right', field: 'registrationLink', sortable: false },
                ],
            }
        },
        methods: {
            registerWebinar(webinar) {
                this.currentRegister = null
                if (webinar.memberExclusive) {
                    if (!this.isLoggedIn || !this.user) {
                        this.currentRegister = webinar
                        this.showLogin = true
                        return
                    }
                    if (!this.getHasMemberExclusiveData) {
                        this.showMemberOnly = true
                        return
                    }
                }
                window.open(webinar.registrationLink)

            },
            serveWebinar(props) {
                let download = props.row
                if (!download) return

                this.currentDownload = null
                if (download.memberExclusive) {
                    if (!this.isLoggedIn || !this.user) {
                        this.currentDownload = props
                        this.showLogin = true
                        return
                    }
                    if (!this.getHasMemberExclusiveData) {
                        this.showMemberOnly = true
                        return
                    }
                }

                this.downloadFile(download.filePath)

                props.expand = false

            },
            getWebinarDownloads() {
                this.$store.dispatch('getWebinarDownloads').then(() => {
                })
            },
            getWebinarSessions() {
                this.$store.dispatch('getWebinarSessions').then(() => {

                })
            },
            updateProductLine() {
                if (this.$route.query.productLine)
                    this.form.productLine = this.productLines?.find(pl => pl.name.toLowerCase() == this.$route.query.productLine.toLowerCase())
                else if (!this.form.productLine) {
                    this.form.productLine = this.productLines[0]
                }
                this.updateRoute()
            },
            updateRoute() {
                let queryParams = {}
                if (this.form.productLine)
                    queryParams.productLine = this.form.productLine?.name.toLowerCase()

                this.$router.replace({
                    path: this.$route.path,
                    query: queryParams,
                }).catch(err => { })
            },
        },
        computed: {
            ...mapState([
                'getHasMemberExclusiveData',
                'getHasMemberExclusivePending',
                'getWebinarDownloadsData',
                'getWebinarDownloadsPending',
                'getWebinarSessionsData',
                'getWebinarSessionsPending',
            ]),
            user() { return this.$store.getters.authUser },
            isLoggedIn() { return this.$store.getters.isLoggedIn },
            webinarDownloads() {
                if (this.getWebinarDownloadsData) {
                    return this.getWebinarDownloadsData?.filter(w => w.productCategory == this.form.productLine?.name).sort((a, b) => a.sortOrder - b.sortOrder)
                }
                return []
            },
            webinarSessions() {
                if (this.getWebinarSessionsData) {
                    return this.getWebinarSessionsData?.filter(w => w.productCategory == this.form.productLine?.name).sort((a, b) => a.sortOrder - b.sortOrder)
                }
                return []
            },
            screenSize() {
                return this.$q.screen
            },
        },
        created() {
            this.updateProductLine()
            if (this.user) this.$store.dispatch('getHasMemberExclusive', this.user.id)
            this.getWebinarDownloads()
            this.getWebinarSessions()
        },
        watch: {
            '$route.query.productLine'(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.updateProductLine()
                }
            },
            isLoggedIn(newVal) {
                if (newVal) {
                    this.showLogin = false
                    if (this.user) {
                        this.$store.dispatch('getHasMemberExclusive', this.user.id).then(() => {
                            if (this.currentDownload) this.serveWebinar(this.currentDownload)
                            if (this.currentRegister) this.registerWebinar(this.currentRegister)
                        })
                    }
                }
            },
        },
    }
</script>
<style lang="scss" scoped>
    @import "../../styles/quasar.variables.scss";

    .img-webinar {
        max-width: 100%;
        max-height: 55px;
        width: unset;
    }

    .my-menu-link {
        color: white;
        background: $secondary;
    }
</style>
